function getOpt (pmData, hasAQI) {
 //console.log('pmData',hasAQI, pmData)
 let xData = pmData.xData;
 let y1Data = pmData.y1Data;
 let y2Data = pmData.y2Data;
 let aqiData = pmData.aqi
 const options = {
  backgroundColor: "transparent",
  tooltip: {
   show: true,
   trigger: 'axis',
   backgroundColor: 'rgba(4, 21, 39, 1)',
   borderWidth: 0,
   textStyle: {
    color: '#fff'
   }
  },
  legend: {
   icon: 'rect',
   itemWidth: 14,
   itemHeight: 4,
   right: '2%',
   top: '8%',
   textStyle: {
    fontSize: 14,
    color: 'rgba(255,255,255,1)',
    padding: [2, 0, 0, 0]
   }
  },
  grid: {
   top: '20%',
   left: '1%',
   right: '1%',
   bottom: '10%',
   containLabel: true,
  },
  xAxis: [{
   type: 'category',
   axisLine: {
    show: true,
    lineStyle: {
     color: '#093E95',
     width: 0.1
    },
   },
   boundaryGap: true,
   axisLabel: {
    textStyle: {
     color: "#9FBAFD",
     fontSize: 12,
     margin: 15,
    },
   },
   axisTick: {
    show: false,
   },
   data: xData,
  }],
  yAxis: [{
   name: '单位：μg/m³',
   nameTextStyle: {
    fontSize: 14,
    color: "#9FBAFD",
    padding: [0, 0, 0, 20]
   },
   type: 'value',
   min: 0,
   minInterval: 50,
   splitLine: {
    show: false,
    lineStyle: {
     color: '#093E95',
     width: 0.3
    }
   },
   axisLine: {
    show: true,
    lineStyle: {
     color: '#093E95',
     width: 1
    }
   },
   axisLabel: {
    margin: 10,
    textStyle: {
     color: '#9FBAFD',
     fontSize: 12,
    },
   },
   axisTick: {
    show: false,
   },
  }],
  series: [
   {
    name: "PM10",
    type: 'line',
    smooth: true,
    showSymbol: false,
    symbolSize: 0,
    lineStyle: {
     normal: {
      width: 1,
      color: "#2EDCB7"
     }
    },
    areaStyle: {
     show: false,
     normal: {
      color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
       offset: 0,
       color: 'rgba(0, 130, 121, 0.5)'
      },
      {
       offset: .5,
       color: 'rgba(1, 201, 178, 0.05)'
      },
      {
       offset: 1,
       color: 'rgba(1, 191, 165, 0)'
      }
      ], false)
     }
    },
    itemStyle: {
     normal: {
      color: "#2EDCB7",
     }
    },
    data: y1Data
   }, {
    name: 'PM2.5',
    type: 'line',
    showSymbol: false,
    smooth: true,
    symbolSize: 0,
    lineStyle: {
     normal: {
      width: 1,
      color: "rgba(57, 183, 229, 1)"
     }
    },
    areaStyle: {
     show: false,
     normal: {
      color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
       offset: 0,
       color: 'rgba(57, 183, 229, 0.5)'
      },
      {
       offset: .5,
       color: 'rgba(1, 201, 178, 0.05)'
      },
      {
       offset: 1,
       color: 'rgba(1, 191, 165, 0)'
      }
      ], false)
     }
    },
    itemStyle: {
     normal: {
      color: "rgba(67, 250, 255, 1)",

     }
    },
    data: y2Data
   }]
 };
 if (hasAQI) {
  options.series.push({
   name: 'AQI',
   type: 'line',
   showSymbol: false,
   smooth: true,
   symbolSize: 0,
   lineStyle: {
    normal: {
     width: 1,
     color: "rgba(123, 104, 238, 1)"
    }
   },
   areaStyle: {
    show: false,
    normal: {
     color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
      offset: 0,
      color: 'rgba(123, 104, 238, 0.5)'
     },
     {
      offset: .5,
      color: 'rgba(123, 104, 238, 0.05)'
     },
     {
      offset: 1,
      color: 'rgba(1, 191, 165, 0)'
     }
     ], false)
    }
   },
   itemStyle: {
    normal: {
     color: "rgba(123, 104, 238, 1)",

    }
   },
   data: aqiData
  })
 }
 return options
}

export default getOpt